<template>
<div v-if="currentItem" class="p-series__gallery2">
  <div class="c-carousel">
    <div class="c-carousel__text">
      <span></span>
    </div>
    <template v-for="(value, key) in currentItem.carousel" :key="value">
    <div class="c-carousel__head">
      <h2>
        <span v-html="value.name"></span>
      </h2>
    </div>
    <div class="c-carousel__wrap">
      <div class="swiper">
        <ul class="swiper-wrapper">
          <li v-for="(src, i) in value.images" :key="src" class="swiper-slide" role="button">
            <img 
            :src="`/collections/luxury/2023/assets/img/carousel/${value.model}/${src}`" 
            alt="" 
            width="340" 
            height="203"
            :data-model="key"
            :data-index="i"
            >
          </li>
        </ul>
        <div class="swiper-ui">
          <div class="swiper-button-next"></div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
    </template>
  </div>
</div>
</template>

<script>
import Swiper, { Navigation, Pagination } from 'swiper';
import { gsap, Quart } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

export default {
  data() {
    return {
      currentItem: null,
    }
  },
  props: ['toName'],
  computed: {
  },
  mounted() {
    this.$nextTick(this.once);
  },
  methods: {
    once(){
      if (this.toName.indexOf('en_') > -1) {
        // 英語版
        this.currentItem = this.$store.getters.getItemEnAll[this.toName.replace('en_', '')];
      } else {
        this.currentItem = this.$store.getters.getItemAll[this.toName];
      }
      this.$nextTick(this.start);
    },
    start() {
      this.$el.querySelectorAll('.swiper').forEach((el, index) => {
        const s = new Swiper(el, {
          modules: [Navigation, Pagination],
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: true,
          speed: 500,
          loop: true,
          // clickedSlide: true,
          breakpoints: {
            901: {
              spaceBetween: 40
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on: {
            init: function (e) {
              // console.log('swiper initialized', e);
            },
            click: this.clickSlide,
          },
        });
      });

      this.$store.commit('setShowCarousel', true);
    },
    clickSlide(swiper, e) {
      const i = e.target.getAttribute('data-model');
      const max = this.currentItem.carousel[i].images.length;
      let index = swiper.clickedIndex;
      
      if (index >= max) {
        index -= max;
      }
      this.openModal(e.target.getAttribute('data-model'), index);
    },
    openModal(series, index) {
      this.$store.commit('setSrcModal', Object.assign({}, this.currentItem.carousel[series]));
      this.$store.commit('setCurrentThumb', index);
      this.$store.commit('setShowModal', true);
    }
  }
}
</script>